/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckContactResponseDto
 */
export interface CheckContactResponseDto {
    /**
     * Whether the contact exists in user's contact list
     * @type {boolean}
     * @memberof CheckContactResponseDto
     */
    _exists: boolean;
    /**
     * Contact ID that was checked
     * @type {string}
     * @memberof CheckContactResponseDto
     */
    contactId: string;
    /**
     * Type of contact that was checked
     * @type {string}
     * @memberof CheckContactResponseDto
     */
    contactType: string;
}

/**
 * Check if a given object implements the CheckContactResponseDto interface.
 */
export function instanceOfCheckContactResponseDto(value: object): value is CheckContactResponseDto {
    if (!('_exists' in value) || value['_exists'] === undefined) return false;
    if (!('contactId' in value) || value['contactId'] === undefined) return false;
    if (!('contactType' in value) || value['contactType'] === undefined) return false;
    return true;
}

export function CheckContactResponseDtoFromJSON(json: any): CheckContactResponseDto {
    return CheckContactResponseDtoFromJSONTyped(json, false);
}

export function CheckContactResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckContactResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        '_exists': json['exists'],
        'contactId': json['contactId'],
        'contactType': json['contactType'],
    };
}

export function CheckContactResponseDtoToJSON(json: any): CheckContactResponseDto {
    return CheckContactResponseDtoToJSONTyped(json, false);
}

export function CheckContactResponseDtoToJSONTyped(value?: CheckContactResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exists': value['_exists'],
        'contactId': value['contactId'],
        'contactType': value['contactType'],
    };
}

